export default {
	NOTES: 'companies/:company_id/notes',
	NOTES_CATEGORIES: 'companies/:company_id/notes/notes-catagories',
	NOTES_CATEGORIES_SETTINGS: 'companies/:company_id/notes/notes-catagories/settings',

}